import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CounterpartyBankAccountResponse {
  /**
   * Account number according to type of format
   */
  @observable
  accountNumber?: string;

  /**
   * Identification of bank
   */
  @observable
  bank?: string;
}
